module.exports = "/images/invite-friend.jpg?5440f5b83a108c3aed174876791c53a9";